export const environment = {
  production: false,
  apiBaseUrl: 'https://backend.uat.design4circularity.be',
  hCaptchaSiteKey: '4e3224fc-d9b6-40f8-b206-c182215a2674',
};
